module.exports = __webpack_public_path__ + "img/g3.1f07d8e5.png";